<template>
  <div id="app-dialog">
    <el-dialog
      :title="!disabled ? '创建应用' : '修改应用'"
      :visible.sync="dialog"
      width="40%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="应用名" prop="name">
          <el-input v-model="ruleForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="!disabled" label="应用编码" prop="appCode">
          <el-input v-model="ruleForm.appCode" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="!disabled" label="所属组" prop="ownerId">
          <el-select v-model="ruleForm.ownerId">
            <el-option
              v-for="(item, index) in userGroup"
              :key="index"
              :label="item.groupName"
              :value="item.groupId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            :rows="4"
            v-model="ruleForm.description"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="formReset">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="submitForm">{{
          !disabled ? "立即创建" : "立即修改"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "app-dialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object
    }
  },

  data() {
    var validateId = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入应用编码"));
      } else {
        //
        let reg = /^[A-Z0-9_]*[A-Z0-9]$/g;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("应用编码只能使用大写字母，数字，下划线组成"));
        }
      }
    };
    return {
      loading: false,
      disabled: false,
      ruleForm: {
        name: "",
        appCode: "",
        ownerType: "GROUP",
        ownerId: "",
        description: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入配置名称",
            trigger: "blur"
          }
        ],
        appCode: [
          {
            required: true,
            validator: validateId,
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: "请输入配置描述",
            trigger: "blur"
          }
        ],
        ownerId: [
          {
            type: "number",
            message: "请选择所属组",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    userGroup() {
      return this.$store.state.userGroup;
    }
  },
  watch: {
    dialog: {
      immediate: true,
      handler(v) {
        if (v && this.dialogData) {
          this.ruleForm = {
            appId: this.dialogData.appId,
            name: this.dialogData.name,
            description: this.dialogData.description
          };
        } else if (v && !this.dialogData) {
          this.ruleForm.ownerId = this.userGroup[0].groupId;
        }
      }
    },
    dialogData: {
      immediate: true,
      handler(v) {
        if (v) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      }
    }
  },
  methods: {
    formReset() {
      this.ruleForm = {
        name: "",
        appCode: "",
        ownerType: "GROUP",
        ownerId: "",
        description: ""
      };
      this.$refs.ruleForm.resetFields();
      this.$emit("update:dialog", false);
    },
    submitForm() {
      this.$refs.ruleForm.validate(vaid => {
        if (vaid) {
          if (!this.disabled) {
            this.newApp();
          } else {
            this.setApp();
          }
        } else {
          return false;
        }
      });
    },
    newApp() {
      this.loading = true;
      this.$http
        .post("/gavial/v1/app", this.ruleForm)
        .then(() => {
          this.$notify({
            type: "success",
            title: "成功",
            message: `${this.ruleForm.name} 创建成功`,
            duration: 2000
          });
          this.formReset();
          this.$emit("refush");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setApp() {
      this.loading = true;
      this.$http
        .put("/gavial/v1/app", this.ruleForm)
        .then(() => {
          this.$notify({
            type: "success",
            title: "成功",
            message: `${this.ruleForm.name} 修改成功`,
            duration: 2000
          });
          this.formReset();
          this.$emit("refush");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
